import React, { useEffect, useState } from 'react';
import parseContent from 'utils/formatNewlines';
import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import axios from 'axios';

import { colors } from 'styles/colors';

const NewsNavigation = () => {
   const [links, setLinks] = useState([]);
   useEffect(() => {
      axios
         .get(`/wp/v2/posts`, {
            params: {
               categories: 119, // Aktualności
               per_page: 32
            }
         })
         .then(({ data }) => {
            const navLinks = data?.map((l) => {
               return {
                  title: l.title.rendered,
                  id: l.id
               };
            });
            setLinks(navLinks);
         });
   }, []);

   return (
      <nav>
         {!!links.length && (
            <NavListLevel1>
               {links.map((l) => (
                  <NavItemLevel1 key={l?.id}>
                     <StyledNavLink to={`/news/${l?.id}`}>{parseContent(l.title)}</StyledNavLink>
                  </NavItemLevel1>
               ))}
            </NavListLevel1>
         )}
      </nav>
   );
};

const StyledNavLink = styled(NavLink)`
   display: block;
   cursor: pointer;
   color: ${colors.neutral10};
   background: none;
   width: 100%;
   text-align: left;
   border: none;
   padding: 0;

   &:hover {
      text-decoration: none;
      color: ${colors.neutral50};
   }

   &.active {
      color: ${colors.primary};
   }
`;

const List = styled.ul`
   display: block;
   list-style-type: none;
   padding: 0;
   margin: 0 20px 0 0;
   width: 100%;
`;

const NavListLevel1 = styled(List)``;

const NavItem = styled.li`
   display: block;
   width: 100%;
   padding: 0;
   margin: 0;
   font-size: 14px;

   button {
      display: block;
      cursor: pointer;
      color: ${colors.neutral10};
      background: none;
      width: 100%;
      text-align: left;
      border: none;
      padding: 0;
   }
`;

const NavItemLevel1 = styled(NavItem)`
   padding: 7px 0;

   ${({ active }) =>
      !active &&
      css`
         &:not(:last-of-type) {
            border-bottom: 1px solid ${colors.neutral60};
         }
      `}
`;

export default NewsNavigation;
